import React, { createContext, useContext, useMemo, type PropsWithChildren } from 'react';

type PolarisEnvironmentContextType = {
	embedded?: boolean;
	isSharedView?: boolean;
	isCollectionView?: boolean;
	isGlobalViewSetting?: boolean;
};

const initialState: PolarisEnvironmentContextType = {
	embedded: undefined,
	isSharedView: undefined,
	isCollectionView: undefined,
	isGlobalViewSetting: undefined,
};

const PolarisEnvironmentContext = createContext(initialState);

type PolarisEnvironmentProviderProps = {
	embedded?: boolean;
	isSharedView?: boolean;
	isCollectionView?: boolean;
	isGlobalViewSetting?: boolean;
};

export const PolarisEnvironmentProvider = ({
	children,
	embedded = false,
	isSharedView = false,
	isCollectionView = false,
	isGlobalViewSetting = false,
}: PropsWithChildren<PolarisEnvironmentProviderProps>): React.JSX.Element => {
	const contextValue = useMemo(
		() => ({
			embedded,
			isSharedView,
			isCollectionView,
			isGlobalViewSetting,
		}),
		[embedded, isSharedView, isCollectionView, isGlobalViewSetting],
	);

	return (
		<PolarisEnvironmentContext.Provider value={contextValue}>
			{children}
		</PolarisEnvironmentContext.Provider>
	);
};

export const useIsEmbedded = (): boolean => {
	const { embedded } = useContext(PolarisEnvironmentContext);
	return embedded === true;
};

export const useIsSharedView = (): boolean => {
	const { isSharedView } = useContext(PolarisEnvironmentContext);
	return isSharedView === true;
};

export const useIsCollectionView = (): boolean => {
	const { isCollectionView } = useContext(PolarisEnvironmentContext);
	return isCollectionView === true;
};

export const useIsGlobalViewSetting = (): boolean => {
	const { isGlobalViewSetting } = useContext(PolarisEnvironmentContext);
	return isGlobalViewSetting === true;
};
